<template>
    <div>
        <base-loader
            v-if="loading"
            class="show-info-loader"
        />
        <template v-else>
            <calculations
                :billing-plan="billingPlan"
                :show="show"
            />
            <edit-card
                :editing-card="editingCard"
                @change="value => editingCard = value"
            />
            <coupon-code
                v-if="! editingCard"
                :billing-plan="billingPlan"
                @change="changeCouponCode"
            />
            <update-subscription-handler
                v-slot:default="{
                    isSubmitting,
                    incrementSubscriptionProducts,
                    replaceSubscriptionProducts,
                }"
                @subscription-updated="$emit('subscription-finished')"
            >
                <base-submit-button
                    v-if="! editingCard"
                    class="btn update-subscription-button"
                    :loading="isSubmitting"
                    @click="handleUpdateClick({
                        incrementSubscriptionProducts,
                        replaceSubscriptionProducts,
                    })"
                >
                    Confirm and subscribe
                </base-submit-button>
            </update-subscription-handler>
        </template>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Calculations from './Calculations';
import CouponCode from '@/components/Billing/CouponCode';
import EditCard from './EditCard';
import UpdateSubscriptionHandler from '@/components/Dashboard/Settings/Billing/UpdateSubscriptionHandler.vue';

export default {
    components: {
        Calculations,
        CouponCode,
        EditCard,
        UpdateSubscriptionHandler,
    },

    props: {
        show: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        billingPlan: {
            required: true,
            type: [Object, Boolean],
        },
    },

    data: () => ({
        editingCard: false,
        couponCode: null,
    }),

    computed: {
        ...mapState(['userSubscription']),

        /**
         * Returns list of Stripe price IDs.
         *
         * @returns {string[]} List of Stripe price IDs.
         */
        priceIds() {
            return [this.billingPlan.prices[this.userSubscription.interval].id];
        },
    },

    methods: {
        /**
         * Sets new coupon code value.
         *
         * @param {string|null} couponCode Coupon code.
         */
        changeCouponCode(couponCode) {
            this.couponCode = couponCode;
        },

        /**
         * Handles update button click.
         */
        handleUpdateClick({
            incrementSubscriptionProducts,
            replaceSubscriptionProducts,
        }) {
            const args = [
                this.userSubscription.dbId,
                this.priceIds,
                this.couponCode,
            ];

            const currentPrice =
                this.show.plan?.prices?.[this.userSubscription.interval];

            if (currentPrice) {
                args.push(currentPrice.id);
            }

            (currentPrice
                ? replaceSubscriptionProducts
                : incrementSubscriptionProducts)(...args);
        },
    },
};
</script>
